import { useNavigate } from 'react-router-dom';
import { Suspense, useContext, useMemo } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import {
    ActuatorAccessoriesPageData,
    ActuatorAccessoriesPageVariables,
    getActuatorAccessoriesPageConfig,
} from 'src/actuators/accessories/ActuatorAccessoriesPageMapping.ts';
import { useFilterLogic } from 'src/modules/common/hooks/useFilterLogic.ts';
import { useCheckMainFilter } from 'src/modules/common/hooks/useCheckMainFilter.ts';
import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';
import { Query } from 'src/modules/common/components/Query/Query.tsx';
import { ActuatorsCheckoutPage } from 'src/actuators/checkout/ActuatorsCheckoutPage.tsx';
import { buildCheckoutVariables } from 'src/actuators/checkout/buildCheckoutVariables.ts';
import { useLocationState } from 'src/actuators/user-input/useLocationState.ts';

export const PrefetchActuatorCheckout = () => {
    const [locationState,, searchParams] = useLocationState();

    const { userSettings, mandatoryFilterConfig } = useContext(ConfigContext);
    const pageConfig = useMemo(() => getActuatorAccessoriesPageConfig(userSettings.currentRegion), [userSettings]);

    if (pageConfig === null) {
        throw new Error('No Page Config!');
    }

    const navigate = useNavigate();

    const [
        filter,
    ] = useFilterLogic([
        ...pageConfig.mainFilterConfig,
        ...pageConfig.additionalFilterConfig,
    ], searchParams);

    useCheckMainFilter({
        filter,
        searchParams,
        navigate,
        filterConfig: [],
    });

    const variables = useMemo(() => buildCheckoutVariables({
        mandatoryFilterConfig,
        filter,
        actuatorLabel: locationState.actuatorLabel,
        userSettings,
    }), [
        mandatoryFilterConfig,
        filter,
        locationState,
        userSettings,
    ]);

    return (
        <Suspense fallback={<SkeletonMainLayout breadcrumbs={false}/>}>
            <Query<ActuatorAccessoriesPageData, ActuatorAccessoriesPageVariables>
                query={pageConfig.query}
                variables={variables}
            >
                {({ data }) => {
                    if (data === undefined) {
                        return (<SkeletonMainLayout/>);
                    }
                    return (
                        <ActuatorsCheckoutPage
                            navigate={navigate}
                            filter={filter}
                            data={data}
                        />
                    );
                }}
            </Query>
        </Suspense>
    );
};
